// src/api/library.js
// ──────────────────────────────────────────────────────────────────────────
// Shared library constants: the built-in catalogue used before anything is
// added in the admin dashboard, plus the department colours the covers use.
//
// Kept here rather than inside the page so the admin "seed built-in titles"
// action and the public page read from the same source.
// ──────────────────────────────────────────────────────────────────────────

export const LIBRARY_DEPTS = ['Agriculture', 'Engineering', 'Hospitality', 'ICT', 'Business', 'General'];
export const LIBRARY_TYPES = ['Manual', 'Guide', 'Reference', 'Past papers'];

export const DEPT_COLOR = {
  Agriculture: '#1F5E3A', Engineering: '#103D8F', Hospitality: '#9C3D2E',
  ICT: '#3B2E7A', Business: '#7A5A1E', General: '#2B3A55',
};

export const librarySlug = (s) =>
  String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

// Shown until the library table has rows. Field names match the table so the
// page can render either source without special-casing.
export const BUILT_IN_LIBRARY = [
  { title: 'Crop production handbook', type: 'Manual', department: 'Agriculture' },
  { title: 'Poultry management guide', type: 'Guide', department: 'Agriculture' },
  { title: 'Fish farming basics', type: 'Guide', department: 'Agriculture' },
  { title: 'Animal husbandry manual', type: 'Manual', department: 'Agriculture' },
  { title: 'Bricklaying & plastering manual', type: 'Manual', department: 'Engineering' },
  { title: 'Carpentry & joinery handbook', type: 'Manual', department: 'Engineering' },
  { title: 'Welding & metal fabrication guide', type: 'Guide', department: 'Engineering' },
  { title: 'Electrical installation reference', type: 'Reference', department: 'Engineering' },
  { title: 'Plumbing systems manual', type: 'Manual', department: 'Engineering' },
  { title: 'Cutting, designing & tailoring', type: 'Manual', department: 'Engineering' },
  { title: 'Food production & cookery', type: 'Manual', department: 'Hospitality' },
  { title: 'Catering & event management', type: 'Guide', department: 'Hospitality' },
  { title: 'Computer fundamentals', type: 'Manual', department: 'ICT' },
  { title: 'Office productivity essentials', type: 'Guide', department: 'ICT' },
  { title: 'Entrepreneurship & business planning', type: 'Guide', department: 'Business' },
  { title: 'Bookkeeping & records basics', type: 'Guide', department: 'Business' },
  { title: 'TEVET past papers', type: 'Past papers', department: 'General' },
  { title: 'Study & exam skills', type: 'Reference', department: 'General' },
].map((r, i) => ({
  ...r,
  slug: librarySlug(r.title),
  // The old page derived the filename from the title, so existing uploads are
  // already named this way — keep that as the default path.
  file_path: `${librarySlug(r.title)}.pdf`,
  featured: i < 4,
  sort: i,
}));
